module.exports = __webpack_public_path__ + "d56ae8498dd9a26d6ab5a30e2b735726.MP3";